
import Title from '~/components/specialist/section-title.vue'

export default {
  name: 'SpecialistTechnologicalArea',
  components: {
    Title
  },
  data() {
    return {
      areas: [
        {
          title: 'データサイエンス',
          description:
            'データから価値ある知見を抽出し、事業課題の解決につなげる技術領域です。事業課題に合わせて幅広い技術領域（CV/生成AI/RL含む）から技術選定し、分析から事業実装まで一気通貫で取り組んでいます。',
          to: this.$link.articlePage('データサイエンス', 'スペシャリスト'),
          icon: '/images/specialist/tech_data_science.svg'
        },
        {
          title: 'LLM / 生成AI',
          description:
            '言語・動画像・音声等の生成技術を活用し、新たな価値を創出する技術領域です。生成AIをサービスのコア技術として設計・実装し、新規サービス開発や業務プロセスの変革に取り組んでいます。',
          to: this.$link.articlePage('LLM・生成AI', 'スペシャリスト'),
          icon: '/images/specialist/tech_llm.svg'
        },
        {
          title: 'コンピュータビジョン',
          description:
            '画像や動画を分析・理解し、現実世界の情報を抽出する技術領域です。試合映像や配信データなど、実サービスの動画像解析を通じた課題解決やユーザー体験の向上に取り組んでいます。',
          to: this.$link.articlePage('コンピュータビジョン', 'スペシャリスト'),
          icon: '/images/specialist/tech_computer_vision.svg'
        },
        {
          title: '強化学習',
          description:
            '試行錯誤を通じて最適な行動を学習し、意思決定を自動化する技術領域です。ゲームAIやレコメンドなど、実サービスへの強化学習の適用に取り組んでいます。',
          to: this.$link.articlePage('強化学習', 'スペシャリスト'),
          icon: '/images/specialist/tech_learning.svg'
        },
        {
          title: '音声AI',
          description:
            '音声認識・音声対話・音声合成等の技術を活用し、新たな体験を創出する技術領域です。実サービスへの音声AIの適用を通じて、コミュニケーション体験の革新に取り組んでいます。',
          to: this.$link.articlePage('音声AI', 'スペシャリスト'),
          icon: '/images/specialist/tech_speech.svg'
        }
      ]
    }
  }
}
